export const getIsAppObjectAppPermission = appPermissionName => {
  return appPermissionName.startsWith('crm.app.objects.') || appPermissionName.startsWith('crm.app.schemas.');
};
export const extractFQNFromAppPermissionName = appPermissionName => {
  if (!getIsAppObjectAppPermission(appPermissionName)) {
    return '';
  }
  const parts = appPermissionName.split('.');
  const FQN = parts[3]; // Get the part after "crm.app.objects" or "crm.app.schemas"

  // If it's not in the expected format with an underscore, return empty string
  if (!FQN || !FQN.includes('_')) {
    return '';
  }

  // Split into ID and name parts
  const [id, ...nameParts] = FQN.split('_');
  // Join name parts and convert to uppercase
  const name = nameParts.join('_').toUpperCase();
  return `${id}_${name}`;
};
export const getAppObjectFQNs = names => {
  const appObjectFQNs = new Set();
  names.forEach(name => {
    if (getIsAppObjectAppPermission(name)) {
      const fqn = extractFQNFromAppPermissionName(name);
      if (fqn) {
        appObjectFQNs.add(fqn);
      }
    }
  });
  return Array.from(appObjectFQNs);
};